import { render, staticRenderFns } from "./SubjectRegisterPage.vue?vue&type=template&id=597b9686&"
import script from "./SubjectRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./SubjectRegisterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideXReverseTransition})
